import { defineMessages } from "react-intl";

export default defineMessages({
  header: {
    id: "homepage.header",
    defaultMessage: "Oiva - Opetushallinnon ohjaus- ja säätelypalvelu"
  },
  infotext: {
    id: "homepage.infotext",
    defaultMessage:
      "Palvelusta löytyvät tällä hetkellä kaikki ajantasaiset ammatillisen \n" +
      "koulutuksen järjestämisluvat sekä vapaan sivistystyön oppilaitosten \n" +
      "ylläpitämisluvat. Myöhemmin Oiva laajennetaan koskemaan myös esi- ja \n" +
      "perusopetuksen sekä lukiokoulutuksen järjestämisluvat. Palvelusta \n" +
      "löytyy lisäksi väestö-, koulutus- ja lupatietoja ja erilaisia \n" +
      "tilastoja ammatillisen koulutuksen osalta."
  }
});
